export const DifferenceWidth = 20;